import { Injectable } from '@angular/core';
import { Observable, of, forkJoin, concat } from 'rxjs';
import { map, tap, switchMap } from 'rxjs/operators';
import * as rxsync from '@ivlasov/rxsync';
import * as _ from 'lodash';
import * as io from 'socket.io-client';
import { EfoEgiService } from './egi.service';
import * as moment from 'moment';
import { ElevationService } from './elevation.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EfoMatchingService {
  //private socketUrl = 'http://socket1.carbrewer.com:3002';
  private socketUrl = 'http://socket.epiphanex.com:5000';
  private socket;

  constructor(
    private efoEgi: EfoEgiService,
    private efoElevation: ElevationService,
    private http: HttpClient,
  ) {}

  matchConsumersToYellowPages(zips): Observable<any> {
    return this.efoEgi.getData('/matching/matchConsumersToYellowPages', {
      zips: zips,
    });
  }

  getSalesMatchDiscrepancies(options): Observable<any> {
    return this.efoEgi.getData('/matching/getSalesMatchDiscrepancies', options);
  }

  removeDuplicateSalesKeys(account_num): Observable<any> {
    return forkJoin([
      this.efoEgi.getData('/omt/removeDuplicateSalesKeys', {
        account_num,
      }),
      this.efoEgi.getData('/matching/removeDuplicateSalesKeys', {
        account_num,
      }),
    ]);
  }
  updateSalesMatchStatus(options): Observable<any> {
    return this.efoElevation.getData(
      '/matching/sales/updateSalesMatchStatus',
      options,
    );
  }
  getSalesMatchReport(options): Observable<any> {
    return this.efoElevation.getData(
      '/matching/sales/getSalesMatchReport',
      options,
    );
  }
  getServiceMatchReport(options): Observable<any> {
    return this.efoElevation.getData(
      '/matching/service/getServiceMatchReport',
      options,
    );
  }
  getCrmMatchReport(options): Observable<any> {
    return this.efoEgi.getData('/matching/getCrmMatchReport', options);
  }
  queueMatchCrm(campaigns): Observable<any> {
    return this.efoEgi.getData('/matching/queueMatchCrm', {
      campaigns: campaigns,
    });
  }
  queueMatchService(campaigns): Observable<any> {
    return this.efoEgi.getData('/matching/queueMatchService', {
      campaigns: campaigns,
    });
  }
  queueMatchSales(campaigns): Observable<any> {
    return this.efoEgi.getData('/matching/queueMatchSales', {
      campaigns: campaigns,
    });
  }
  queueMatching(campaigns): Observable<any> {
    return this.efoEgi.getData('/matching/queueMatching', {
      campaigns: campaigns,
    });
  }
  getSalesMatchComparisonReport(options): Observable<any> {
    return this.efoEgi.getData(
      '/matching/getSalesMatchComparisonReport',
      options,
    );
  }
  getSalesMatchReportSummary(options): Observable<any> {
    return this.efoElevation.getData(
      '/matching/sales/getSalesMatchReportSummary',
      options,
    );
  }
  queueSalesServiceUpdate(campaigns): Observable<any> {
    return this.efoEgi.getData('/matching/queueSalesServiceUpdate', {
      campaigns: campaigns,
    });
  }
  updateMatchSalesDiscrepancies(account_num, campaign_key): Observable<any> {
    return this.efoEgi.getData('/matching/updateMatchSalesDiscrepancies', {
      account_num,
      campaign_key,
    });
  }
  autoAcceptSalesMatches(account_num, campaign_key): Observable<any> {
    return this.efoEgi.getData('/matching/autoAcceptSalesMatches', {
      account_num,
      campaign_key,
    });
  }
  autoAcceptServiceMatches(account_num, campaign_key): Observable<any> {
    return this.efoEgi.getData('/matching/autoAcceptServiceMatches', {
      account_num,
      campaign_key,
    });
  }

  getConsumerMarketingMatches(options): Observable<any> {
    return this.efoElevation.getData(
      '/matching/sales/getConsumerMarketingMatches',
      options,
    );
  }
  getVehicleSales(account_num, sales_key): Observable<any> {
    return this.efoElevation.getData('/matching/sales/getVehicleSales', {
      account_num,
      sales_key: sales_key,
    });
  }
  getVehicleSale(account_num, sales_key): Observable<any> {
    return this.efoEgi.getData('/matching/getVehicleSale', {
      account_num,
      sales_key: sales_key,
    });
  }
  // getSalesMatchReport(options): Observable<any> {
  //   return this.efoEgi.getData('/matching/getSalesMatchReport', options)
  // }
  getServiceMatchDiscrepancies(options): Observable<any> {
    return this.efoEgi.getData(
      '/matching/getServiceMatchDiscrepancies',
      options,
    );
  }
  getConsumerMarketingMatchesService(options): Observable<any> {
    return this.efoElevation.getData(
      '/matching/service/getConsumerMarketingMatches',
      options,
    );
  }
  getConsumerMarketingMatchesCrm(options): Observable<any> {
    return this.efoEgi.getData(
      '/matching/getConsumerMarketingMatchesCrm',
      options,
    );
  }
  getVehicleRepairOrders(account_num, repair_order_key): Observable<any> {
    return this.efoElevation.getData(
      '/matching/service/getVehicleRepairOrders',
      {
        account_num,
        repair_orders_key: repair_order_key,
      },
    );
  }
  getCrmLeads(account_num, crm_uuid): Observable<any> {
    return this.efoEgi.getData('/matching/getCrmLeads', {
      account_num,
      crm_uuid: crm_uuid,
    });
  }

  getServiceMatchComparisonReport(options): Observable<any> {
    return this.efoEgi.getData(
      '/matching/getServiceMatchComparisonReport',
      options,
    );
  }
  getServiceMatchReportSummary(options): Observable<any> {
    return this.efoElevation.getData(
      '/matching/service/getServiceMatchReportSummary',
      options,
    );
  }
  getCrmMatchComparisonReport(options): Observable<any> {
    return this.efoEgi.getData(
      '/matching/getCrmMatchComparisonReport',
      options,
    );
  }
  getCrmMatchDiscrepancies(options): Observable<any> {
    return this.efoEgi.getData('/matching/getCrmMatchDiscrepancies', options);
  }

  updateServiceMatchStatus(options): Observable<any> {
    return this.efoElevation.getData(
      '/matching/service/updateServiceMatchStatus',
      options,
    );
  }
  //getServiceMatchComparisonReport(): Observable<any> {
  //   return this.efoEgi.getData('/matching/getServiceMatchComparisonReport', {})
  // }
  // autoAcceptSalesMatches(): Observable<any> {
  //   return this.efoEgi.getData('/matching/autoAcceptSalesMatches',{account_num:campaign.account_num,campaign_key:campaign.campaign_key})
  //}
  updateSalesServiceInfo(account_num, campaign_key): Observable<any> {
    return this.efoEgi.getData('/matching/updateSalesServiceInfo', {
      account_num,
      campaign_key,
    });
  }
  updateMatchServiceDiscrepancies(account_num, campaign_key): Observable<any> {
    return this.efoEgi.getData('/matching/updateMatchServiceDiscrepancies', {
      account_num,
      campaign_key,
    });
  }
  getOemSalesSummaryReport(account_num): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/matching/getOemSalesSummaryReport`,
      {
        campaigns: [{ account_num }],
      },
    );
  }
  getOemSalesSummaryReportFull(): Observable<any> {
    var theMonth = moment().add(-10, 'days').format('YYYY-MM');
    return this.http
      .post<any>(
        `${environment.nestElevationApiUrl}/omt/getActiveCampaigns`,
        {},
      )
      .pipe(
        switchMap((rs) => {
          var campaigns = _.map(rs, (d) => {
            return {
              account_num: d.account_num,
              campaign_key: d.campaign_key,
              name: d.Name,
            };
          });
          return this.http
            .post(
              `${environment.nestElevationApiUrl}/matching/getOemSalesSummaryReportFull`,
              {
                campaigns,
              },
            )
            .pipe(
              map((rs2) => {
                return _.map(campaigns, (d) => {
                  return _.extend(
                    d,
                    _.find(rs2, {
                      account_num: d.account_num,
                      deal_month: theMonth,
                    }),
                  );
                });
              }),
            );
        }),
      );
  }
  getOemSalesDetailsReport(account_num, deal_month): Observable<any> {
    return this.http
      .post<any>(
        `${environment.nestElevationApiUrl}/matching/getOemSalesDetailsReport`,
        {
          account_num,
          deal_month,
        },
      )
      .pipe(
        map((rs) => {
          /*
            Match - 300
            New Car - 200
            New Customer - 200
            Trade NonOEM Brand - 200 or No Trade-in - 100
            In the OEM authorized area - 100
             */
          _.each(rs, (d) => {
            d.is_new_car =
              d.vehicle_type.toUpperCase().substr(0, 1) == 'N' ? 1 : 0;
            d.oem_score = 0;
            d.oem_score += d.is_match ? 300 : 0;
            d.oem_score += d.is_new_car ? 200 : 0;
            d.oem_score += d.is_new_customer ? 200 : 0;
            d.oem_score += d.is_non_oem_trade ? 200 : 0;
            d.oem_score += d.is_no_trade ? 100 : 0;
            d.is_authorized = d.is_in_territory ? 1 : 0;
            d.oem_score += d.is_authorized ? 100 : 0;
            d.oem_score = d.is_oem ? d.oem_score : 0;
            d.vehicle_type =
              d.vehicle_type.toUpperCase().substr(0, 1) == 'N'
                ? 'New'
                : d.is_oem
                ? 'CPO'
                : 'Used';
          });
          return rs;
        }),
      );
  }
  getOemServiceSummaryReport(account_num): Observable<any> {
    return this.efoEgi.getData('/matching/getOemServiceSummaryReport', {
      campaigns: [{ account_num }],
    });
  }
  getOemServiceSummaryReportFull(): Observable<any> {
    const theMonth = moment().add(-10, 'days').format('YYYY-MM');
    return this.http
      .post<any>(
        `${environment.nestElevationApiUrl}/omt/getActiveCampaigns`,
        {},
      )
      .pipe(
        switchMap((rs) => {
          const campaigns = _.map(rs, (d) => {
            return {
              account_num: d.account_num,
              campaign_key: d.campaign_key,
              name: d.name,
            };
          });
          return this.efoEgi
            .getData('/matching/getOemServiceSummaryReportFull', {
              campaigns: campaigns,
            })
            .pipe(
              map((rs2) => {
                return _.map(campaigns, (d) => {
                  return _.extend(
                    d,
                    _.find(rs2, {
                      account_num: d.account_num,
                      close_month: theMonth,
                    }),
                  );
                });
              }),
            );
        }),
      );
  }
  getOemServiceDetailsReport(account_num, close_month): Observable<any> {
    return this.efoEgi
      .getData('/matching/getOemServiceDetailsReport', {
        account_num,
        close_month,
      })
      .pipe(
        map((rs) => {
          /*
            Match - 300
            New Car - 200
            New Customer - 200
            Trade NonOEM Brand - 200 or No Trade-in - 100
            In the OEM authorized area - 100
             */
          _.each(rs, (d) => {
            d.oem_score = 0;
            d.oem_score += d.is_match ? 300 : 0;
            d.oem_score += d.is_new_car ? 200 : 0;
            d.oem_score += d.is_new_customer ? 200 : 0;
            d.oem_score += d.is_non_oem_trade ? 200 : 0;
            d.oem_score += d.is_no_trade ? 100 : 0;
            d.is_authorized = d.is_in_territory ? 1 : 0;
            d.oem_score += d.is_authorized ? 100 : 0;
            d.oem_score = d.is_oem ? d.oem_score : 0;
          });
          return rs;
        }),
      );
  }
  triggerBatchMatching(): Observable<any> {
    return this.efoEgi.getData('/matching/triggerBatchMatching', {});
  }
  matchSalesToTargetSister(): Observable<any> {
    return this.efoEgi.getData('/matching/matchSalesToTargetSister', {});
  }

  matchSalesToTargetPBI(): Observable<any> {
    return this.efoEgi.getData('/matching/matchSalesToTargetPBI', {});
  }
  matchServiceToTargetPBI(): Observable<any> {
    return this.efoEgi.getData('/matching/matchServiceToTargetPBI', {});
  }
  accountMatchingSettingsReport(): Observable<any> {
    return this.efoEgi.getData(
      '/matching/getAccountMatchingSettingsReport',
      {},
    );
  }

  matchCrmToTarget(account_num, campaign_key): Observable<any> {
    return this.efoEgi.getData('/matching/matchCrmToTarget', {
      account_num,
      campaign_key,
    });
  }

  updateMatchingTypeReportAll(): Observable<any> {
    return this.http.get(
      `${environment.nestElevationApiUrl}/targeting/updateMatchingTypeReportAll`,
    );
  }
  updateMatchingTypeReport(account_num?): Observable<any> {
    const pvars = account_num ? { account_num } : {};
    const qs = new URLSearchParams(pvars).toString();
    return this.http.get(
      `${environment.nestElevationApiUrl}/targeting/updateMatchingTypeReport?${qs}`,
    );
  }
  getMatchingTypeReport(campaign_key?): Observable<any> {
    const pvars = campaign_key ? { campaign_key } : {};
    const qs = new URLSearchParams(pvars).toString();
    return this.http.get(
      `${environment.nestElevationApiUrl}/matching/getMatchingTypeReport?${qs}`,
    );
  }
  getMatchingTypeReportSummary(campaign_key): Observable<any> {
    return this.http.get(
      `${environment.nestElevationApiUrl}/matching/getMatchingTypeReportSummary?campaign_key=${campaign_key}`,
    );
  }
  addEgiStatusSales(options): Observable<any> {
    return this.efoEgi.getData('/matching/addEgiStatusSales', options);
  }
  addEgiStatusRepairOrder(options): Observable<any> {
    return this.efoEgi.getData('/matching/addEgiStatusRepairOrder', options);
  }

  getDmsSalesByCustNum(account_num, cust_num, campaign_key): Observable<any> {
    return this.efoElevation.getData('/matching/sales/getDmsSalesByCustNum', {
      account_num,
      cust_num: cust_num,
      campaign_key,
    });
  }

  getDmsServiceByVin(account_num, vin): Observable<any> {
    return this.efoElevation.getData('/matching/service/getDmsServiceByVin', {
      account_num,
      vin: vin,
    });
  }

  getDmsServiceByCustNum(account_num, cust_num, campaign_key): Observable<any> {
    return this.efoElevation.getData(
      '/matching/service/getDmsServiceByCustNum',
      {
        account_num,
        cust_num: cust_num,
        campaign_key,
      },
    );
  }

  getDmsSalesByVin(account_num, vin): Observable<any> {
    return this.efoElevation.getData('/matching/sales/getDmsSalesByVin', {
      account_num,
      vin: vin,
    });
  }

  getExcludedCustNums(account_num): Observable<any> {
    return this.efoElevation.getData('/matching/getExcludedCustNums', {
      account_num,
    });
  }

  saveExcludedCustNums(account_num, cust_num, is_excluded): Observable<any> {
    return this.efoElevation.postData('/matching/excludeCustNum', {
      account_num,
      cust_num: cust_num,
      is_excluded: is_excluded,
    });
  }

  public socketListen = () => {
    if (_.isUndefined(this.socket)) {
      this.socket = io(this.socketUrl, {
        transports: ['websocket'],
      });
      this.socket.on('connect', () => {
        this.socket.emit(
          'new-message',
          'portal service connected: matching.service',
        );
      });
    }
    return new Observable((observer) => {
      this.socket.on('matching', (data) => {
        observer.next(data);
      });
    });
  };
}
